import httpRequest from '@/utils/request';

const getDepartmentUrl = '/Permission/department';

export const getDepartments = (): Promise<IDepartment.IResponse.IData> => {
  return httpRequest.get(getDepartmentUrl);
};
